// @flow
import React, { useMemo } from 'react';
import classNames from 'classnames/bind';
import path from 'ramda/es/path';

import * as shippingStatuses from 'app/common/actions/shop/order/shippingStatuses';

import getShippingStatusNames from './getShippingStatusNames';
import styles from './ShippingStatus.module.scss';;


const cx = classNames.bind(styles);

type Props = {
  status: ?$Values<typeof shippingStatuses>
};

const ShippingStatus = ({ status }: Props) => {
  const title = useMemo(() => (status
    ? path([status, 'title'], getShippingStatusNames())
    : ''
  ), [status]);

  return (
    <span className={cx({
      waiting: status === shippingStatuses.SHIPPING_STATUS_WAITING,
      shipping: status === shippingStatuses.SHIPPING_STATUS_SHIPPING,
      ready_for_issue: status === shippingStatuses.SHIPPING_STATUS_READY_FOR_ISSUE,
      issued: status === shippingStatuses.SHIPPING_STATUS_ISSUED,
      partially_issued: status === shippingStatuses.SHIPPING_STATUS_PARTIALLY_ISSUED,
      canceled_by_customer: status === shippingStatuses.SHIPPING_STATUS_CANCELED_BY_CUSTOMER,
    })}
    >
      {title}
    </span>
  );
};

export default ShippingStatus;
